import styled, { css } from "styled-components";
import { device } from "../../styles/mediaQueries";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

// Applies to LoginMessage, LoginPassword and ChangePassword components
export const LoginWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 414px;
    margin: 0 auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    row-gap: 25px;

    p {
      color: #aca9b3;
      font-weight: 100;
      margin-bottom: 0px;
    }

    @media (${device.laptop}) {
      margin: 10vh auto 0;
      justify-content: start;
    }
  `}
`;
